"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_METADATA = exports.ServerList = void 0;
exports.serverURLFromOptions = serverURLFromOptions;
const url_js_1 = require("./url.js");
/**
 * Contains the list of servers available to the SDK
 */
exports.ServerList = [
    "/",
];
function serverURLFromOptions(options) {
    let serverURL = options.serverURL;
    const params = {};
    if (!serverURL) {
        const serverIdx = options.serverIdx ?? 0;
        if (serverIdx < 0 || serverIdx >= exports.ServerList.length) {
            throw new Error(`Invalid server index ${serverIdx}`);
        }
        serverURL = exports.ServerList[serverIdx] || "";
    }
    const u = (0, url_js_1.pathToFunc)(serverURL)(params);
    return new URL(u);
}
exports.SDK_METADATA = {
    language: "typescript",
    openapiDocVersion: "v6.7.1",
    sdkVersion: "0.40.1",
    genVersion: "2.657.1",
    userAgent: "speakeasy-sdk/typescript 0.40.1 2.657.1 v6.7.1 @agentsoftware/kraken-ts-sdk",
};
//# sourceMappingURL=config.js.map